import React, { useState, useEffect } from "react";
import { Button, Col, Form } from "react-bootstrap";
import { connect } from "react-redux";
import AppSpinner from "../Extras/AppSpinner/AppSpinner";
import {
  redirectBaseUrl,
  wompiBaseUrl,
  epaycoBaseUrl,
  epaycoPrivateKey,
  epaycoPublicKey,
} from "../../utils/paymentKeys";
import { apiUrl, businessName, mainApiUrl } from "../../utils/consts";
import { formatMoney } from "../../utils/formatMoney";
import "./styles/psePayment.scss";

const select = (state) => {
  return {
    user: state.auth.user,
    userId: state.auth.userId,
    token: state.auth.token,
  };
};

function ConnectedPsePayment(props) {
  const [loading, setLoading] = useState(true);
  const [creatingTransaction, setCreatingTransaction] = useState(false);
  const [validated, setValidated] = useState(false);
  //const [acceptanceToken, setAcceptanceToken] = useState(null);
  const [permalink] = useState(null);
  const [transactionId, setTransactionId] = useState("");
  const [financialInstitutions, setFinancialInstitutions] = useState([]);
  const [email, setEmail] = useState(props.user.email);
  const [cellPhone, setCellPhone] = useState(props.user.cellPhone || "");
  const [docType, setDocType] = useState(props.user.identificationType || "CC");
  const [userDocument, setUserDocument] = useState(
    props.user.identification || ""
  );
  const [userType, setUserType] = useState("0");
  const [institutionSelected, setInstitutionSelected] = useState("0");
  let interval;

  useEffect(() => {
    getFinancialInstitutions();
  }, []);

  useEffect(() => {
    if (financialInstitutions && financialInstitutions.length > 0)
      setLoading(false);
  }, [financialInstitutions]);

  useEffect(() => {
    if (transactionId) interval = setInterval(checkTransaction, 2000);
  }, [transactionId]);

  /*   const getWompiData = async () => {
    const acceptanceTokenResp = await fetch(`${wompiBaseUrl}/merchants/${wompiPublicKey}`);
    const acceptanceTokenData = await acceptanceTokenResp.json();

    const { data } = acceptanceTokenData;

    if (data) {
      const presignedData = data.presigned_acceptance;

      setAcceptanceToken(presignedData.acceptance_token);
      setPermalink(presignedData.permalink);
    }
  }; */

  const getTokenApify = async () => {
    const tokenApifyResponse = await fetch(`${epaycoBaseUrl}/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Basic " +
          new Buffer.from(epaycoPublicKey + ":" + epaycoPrivateKey).toString(
            "base64"
          ),
      },
    });

    const tokenApifyData = await tokenApifyResponse.json();
    return tokenApifyData.token;
  };

  const getFinancialInstitutions = async () => {
    /*  const financialInstitutionsFetch = await fetch(`${wompiBaseUrl}/pse/financial_institutions`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${wompiPublicKey}`
      }
    });

    const financialInstitutionsData = await financialInstitutionsFetch.json();

    if (financialInstitutionsData.data) {
      setFinancialInstitutions(financialInstitutionsData.data);
      setInstitutionSelected(financialInstitutionsData.data[0].financial_institution_code);
    } */

    //EPAYCO
    const token_apify = await getTokenApify();
    const financialInstitutionsFetch = fetch(
      `${epaycoBaseUrl}/payment/pse/banks`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token_apify}`,
        },
      }
    );
    const financialInstitutionsResponse = await financialInstitutionsFetch;
    const financialInstitutionsData =
      await financialInstitutionsResponse.json();
    setFinancialInstitutions(financialInstitutionsData.data);
  };

  const checkTransaction = async () => {
    try {
      const transactionResponse = await fetch(
        `${wompiBaseUrl}/transactions/${transactionId}`
      );
      const transaction = await transactionResponse.json();
      const { data } = transaction;

      if (
        data &&
        data.payment_method &&
        data.payment_method.extra &&
        data.payment_method.extra.async_payment_url
      ) {
        clearInterval(interval);

        const paymentUrl = data.payment_method.extra.async_payment_url;
        if (window.location.href !== paymentUrl)
          window.location.href = paymentUrl;
      }
    } catch (err) {
      clearInterval(interval);
    }
  };

  const createPsePayment = async () => {
    const {
      token,
      userId,
      products,
      amount,
      deliveryInfo,
      paymentType,
      benefitCategory,
      benefitApplicationId,
      requestedBenefitId,
    } = props;

    const body = {
      userId,
      token,
      businessName,
      products,
      amount,
      paymentMethod: "PSE",
      paymentType,
      benefitCategory,
      benefitApplicationId,
      requestedBenefitId,
    };

    if (products && products.length > 0 && deliveryInfo) {
      body.deliveryInfo =
        deliveryInfo.street +
        " " +
        (deliveryInfo.extra ? deliveryInfo.extra : "") +
        " " +
        (deliveryInfo.area ? deliveryInfo.area : "") +
        ", " +
        deliveryInfo.city +
        ", " +
        deliveryInfo.state +
        ", " +
        deliveryInfo.country +
        ", " +
        deliveryInfo.phone;
    }

    const paymentResponse = await fetch(`${apiUrl}/payments/create`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });

    const paymentData = await paymentResponse.json();
    const { reference } = paymentData;

    return reference;
  };

  const createTransaction = async () => {
    const { amount } = props;
    const reference = await createPsePayment();
    const ipResponse = await fetch(`${mainApiUrl}/payments/ip_address`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    const ipData = await ipResponse.json();
    const ip = ipData.ip;
    const body = JSON.stringify({
      bank: institutionSelected,
      value: `${amount}`,
      docType,
      docNumber: userDocument,
      name: props.user.firstName + " " + props.user.lastName,
      email,
      cellPhone: cellPhone,
      urlResponse: `${redirectBaseUrl}/pago/resultado?id=${reference}`,
      ip,
      urlConfirmation: `https://nibi.com.co/payments/transaction/events/epayco`,
      methodConfirmation: "GET",
      extra1: reference,
      extra2: `Pago CEMEX`,
    });
    const token_apify = await getTokenApify();

    const transactionResponse = await fetch(
      `${epaycoBaseUrl}/payment/process/pse`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token_apify}`,
        },
        body,
      }
    );

    const transactionData = await transactionResponse.json();
    if (!transactionData.success) {
      setCreatingTransaction(false);
      //Enviar log a BD
      await fetch(`${mainApiUrl}/nibiLogs/create`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          content: transactionData,
          userId: props.user._id,
          context: "Error en transacción CEMEX por PSE",
        }),
      });
      return;
    }
    window.open(transactionData.data.urlbanco, "_self");

    const transactionId = transactionData.data.id;
    return transactionId;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    event.stopPropagation();

    setValidated(true);

    const form = event.currentTarget;

    if (form.checkValidity() && institutionSelected !== "0") {
      setCreatingTransaction(true);
      const transactionId = await createTransaction();

      if (transactionId) setTransactionId(transactionId);
    }
  };

  if (loading || creatingTransaction) {
    return (
      <div className="pse-payment-component">
        <AppSpinner />
        {creatingTransaction && (
          <h4 className="transaction-message">
            Estamos procesando la transacción. Por favor espera.
          </h4>
        )}
      </div>
    );
  }

  return (
    <div className="pse-payment-component">
      <Form noValidate validated={validated} onSubmit={handleSubmit}>
        <Form.Row>
          <Form.Group as={Col} lg={6}>
            <Form.Label>Monto</Form.Label>
            <Form.Control value={formatMoney(props.amount)} disabled={true} />
          </Form.Group>
          <Form.Group as={Col} lg={6}>
            <Form.Label>Número de celular</Form.Label>
            <Form.Control
              type="text"
              placeholder="Celular"
              value={cellPhone}
              onChange={(event) => setCellPhone(event.target.value)}
              required
            />
            <Form.Control.Feedback type="invalid">
              Ingresa número de celular.
            </Form.Control.Feedback>
          </Form.Group>
        </Form.Row>
        <Form.Row>
          <Form.Group as={Col} lg={6}>
            <Form.Label>Institución financiera</Form.Label>
            <Form.Control
              as="select"
              className={institutionSelected === "0" ? "invalid-value" : ""}
              value={institutionSelected}
              onChange={(event) => setInstitutionSelected(event.target.value)}
            >
              {financialInstitutions.map((institution) => (
                <option key={institution.bankCode} value={institution.bankCode}>
                  {institution.bankName}
                </option>
              ))}
            </Form.Control>
            {validated && institutionSelected === "0" && (
              <div className="text-invalid">Selecciona tu banco.</div>
            )}
          </Form.Group>
          <Form.Group as={Col} lg={6}>
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              required
            />
            <Form.Control.Feedback type="invalid">
              Ingresa un email válido.
            </Form.Control.Feedback>
          </Form.Group>
        </Form.Row>

        <Form.Row>
          <Form.Group as={Col} lg={3} xs={6}>
            <Form.Label>Tipo de persona</Form.Label>
            <Form.Control
              as="select"
              value={userType}
              onChange={(event) => setUserType(event.target.value)}
            >
              <option value="0">Natural</option>
              <option value="1">Jurídica</option>
            </Form.Control>
          </Form.Group>

          <Form.Group as={Col} lg={3} xs={6}>
            <Form.Label>Tipo de documento</Form.Label>
            <Form.Control
              as="select"
              value={docType}
              onChange={(event) => setDocType(event.target.value)}
            >
              <option value="CC">CC</option>
              <option value="NIT">NIT</option>
            </Form.Control>
          </Form.Group>

          <Form.Group as={Col} lg={6}>
            <Form.Label>Número de documento</Form.Label>
            <Form.Control
              type="text"
              placeholder="Documento"
              value={userDocument}
              onChange={(event) => setUserDocument(event.target.value)}
              required
            />
            <Form.Control.Feedback type="invalid">
              Ingresa tu documento.
            </Form.Control.Feedback>
          </Form.Group>
        </Form.Row>
        <Form.Row>
          <Col xs={12}>
            <div className="custom-control custom-checkbox">
              <input
                type="checkbox"
                className="custom-control-input"
                id="permalinkCheckBox1"
                required
              />
              <label
                className="custom-control-label"
                htmlFor="permalinkCheckBox1"
              >
                Acepto haber leído los{" "}
                <a href={permalink} target="_blank" rel="noopener noreferrer">
                  términos y condiciones y la política de privacidad
                </a>{" "}
                para hacer este pago.
              </label>
            </div>
          </Col>

          <Button
            className="app-button"
            type="submit"
            style={{ marginTop: "15px" }}
          >
            Continuar
          </Button>
        </Form.Row>
      </Form>
    </div>
  );
}

const PsePayment = connect(select)(ConnectedPsePayment);

export default PsePayment;
